import { WashHistoryQueryArgs } from '@/apps/washing/types/IWashing';
import { buildWashQueryParams } from '@/apps/washing/utils/buildWashQueryParams';

/**
 * Serialises the history request with the PascalCase names the backend binds
 * (connect-bus-api src/ConnectBus.Application/Features/Wash/Common/Requests/GetWashHistoryRequest.cs:13-32):
 * `From` and `To` always, the scope as repeated `ContractId` /
 * `MonitoredDepotId` entries, and `EventType` only when one type is chosen.
 */
export const buildWashHistoryQueryParams = (
  args: WashHistoryQueryArgs
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  searchParams.append('From', args.from);
  searchParams.append('To', args.to);

  buildWashQueryParams({
    contractIds: args.contractIds,
    monitoredDepotIds: args.monitoredDepotIds,
  })?.forEach((value, key) => {
    searchParams.append(key, value);
  });

  if (args.eventType !== undefined) {
    searchParams.append('EventType', String(args.eventType));
  }

  return searchParams;
};
